import { FULL_MESSAGE } from '../../types';

const initialState = {
    open: false,
    title: '',
    content: '',
    cancelText: '',
    confirmText: '',
    hiddenCancelButton: false,
    hiddenConfirmButton: false,
    disabledConfirmButton: false,
    onCancel: () => {},
    onConfirm: () => {},
};

// ==============================|| MENU REDUCER ||============================== //

const messageReducer = (state = initialState, action) => {
    switch (action.type) {
        case FULL_MESSAGE.Open:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default messageReducer;
